import './buttonsCardListView.less'
import { PAGE_VIEW_VALUES } from '../../constants'
import { Button } from 'semantic-ui-react'
import React from 'react'
import { ListDashes as IconListDashes, SquaresFour as IconSquaresFour } from 'phosphor-react'

interface IProps {
  pageView: PAGE_VIEW_VALUES
  className?: string
  onClick: (value: PAGE_VIEW_VALUES) => void
}

const ButtonsCardListView = (props: IProps): React.ReactElement => {
  const { pageView = PAGE_VIEW_VALUES.card, className = '', onClick } = props

  const colorActive = 'var(--color-white)'
  const colorInactive = '#959DA5'

  return (
    <div className={`buttons-card-list-view ${className}`} data-test-id="button-card-list-view">
      <Button
        className={`button-view card`}
        onClick={() => onClick(PAGE_VIEW_VALUES.card)}
        active={pageView === PAGE_VIEW_VALUES.card}
        content={
          <IconSquaresFour
            size={20}
            color={pageView === PAGE_VIEW_VALUES.card ? colorActive : colorInactive}
            weight={pageView === PAGE_VIEW_VALUES.card ? 'fill' : 'regular'}
          />
        }
      />
      <Button
        className={`button-view list`}
        onClick={() => onClick(PAGE_VIEW_VALUES.list)}
        active={pageView === PAGE_VIEW_VALUES.list}
        content={
          <IconListDashes
            color={pageView === PAGE_VIEW_VALUES.list ? colorActive : colorInactive}
            size={20}
            weight="regular"
          />
        }
      />
    </div>
  )
}

export default ButtonsCardListView
